export default "__VITE_ASSET__spGp4xW8__"